import { render, staticRenderFns } from "./compartilhamento.vue?vue&type=template&id=596eafe0&scoped=true"
import script from "./compartilhamento.vue?vue&type=script&lang=js"
export * from "./compartilhamento.vue?vue&type=script&lang=js"
import style0 from "./compartilhamento.vue?vue&type=style&index=0&id=596eafe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596eafe0",
  null
  
)

export default component.exports